import React from 'react';
import { Link } from 'react-router-dom';

const AuthFooter = () => {
  const currentYear = new Date()?.getFullYear();

  return (
    <footer className="mt-auto py-8 border-t border-border bg-surface">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
          {/* Copyright */}
          <div className="text-sm text-muted-foreground">
            © {currentYear} EventGrid. All rights reserved.
          </div>

          {/* Links */}
          <div className="flex items-center space-x-6">
            <Link
              to="/privacy"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Terms of Service
            </Link>
            <Link
              to="/support"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Support
            </Link>
          </div>

          {/* Security Badge */}
          <div className="flex items-center space-x-2 text-xs text-muted-foreground">
            <div className="flex items-center justify-center w-4 h-4 bg-success rounded-full">
              <div className="w-2 h-2 bg-white rounded-full"></div>
            </div>
            <span>Secured with SSL</span>
          </div>
        </div>

        {/* Additional Info */}
        <div className="mt-6 pt-6 border-t border-border">
          <div className="text-center">
            <p className="text-xs text-muted-foreground max-w-2xl mx-auto">
              EventGrid is a premium event discovery and booking platform. We connect event enthusiasts 
              with amazing experiences while providing hosts with powerful management tools. 
              Join our community of over 2 million satisfied users.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default AuthFooter;